export const PHONE_NUMBER_PATTERN = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const LOCATION_PATTERN = /^[a-zA-Z]+, [a-zA-Z]+$/;
